<template>
  <div class="m-b-lg">
    <div class="border-bottom p-t-md p-b-md">
      <div class="container">
        <a
          @click.prevent="$router.go(-1)"
        >
          <i
            class="fas fa-arrow-circle-left"
            aria-hidden="true"
          />
          Go back
        </a>
      </div>
    </div>
    <div class="container">
      <div class="columns">
        <div class="column">
          <faq :faqs="faqs" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FAQ from '@/components/FAQ';
export default {
  name: 'FAQPage',
  components: {
    faq: FAQ,
  },
  data() {
    return {
      faqs: this.$wording.faq,
    };
  },
  methods: {
  },
};
</script>

<style>

</style>